export default {
  reset_password_title: "Restablecer contraseña",
  invalid_reset_token: "El enlace de restablecimiento de contraseña es inválido o ha expirado",
  invalid_reset_token_desc:
    "El enlace de restablecimiento de contraseña que proporcionó es inválido o ha expirado. Por favor solicite un nuevo enlace de restablecimiento de contraseña.",
  password_reset_success: "Su contraseña se ha restablecido con éxito",
  password_reset_success_desc:
    "Su contraseña se ha cambiado con éxito. Ahora puede iniciar sesión con su nueva contraseña.",
  reset_password_desc: "Por favor ingrese su nueva contraseña a continuación",
  password_required: "Por favor ingrese su contraseña",
  password_invalid:
    "La contraseña debe tener al menos 8 caracteres e incluir letras, números y caracteres especiales",
  password_placeholder: "Ingrese su contraseña",
  confirm_password_required: "Por favor confirme su contraseña",
  passwords_do_not_match: "Las dos contraseñas ingresadas no coinciden",
  confirm_password_placeholder: "Confirmar contraseña",
  reset_password: "Establecer nueva contraseña",
  password_same_as_old: "La nueva contraseña no puede ser igual a la contraseña anterior",
  password_reset_failed: "Error al restablecer la contraseña",
};
